var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _ellipse, _g, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBridge = function SvgBridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 446,
    height: 188,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m89.655 62.816-10.25 3.968 10.25 4.63 9.258-4.63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m98.363 79.183-8.709 3.307V71.416l9.259-4.629z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m79.954 79.592 9.7 2.49V71.415l-10.25-4.629z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m367.84 62-10.25 3.968 10.25 4.63 9.259-4.63z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m376.549 78.367-8.709 3.306V70.6l9.258-4.63z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m358.14 78.776 9.7 2.489V70.6l-10.25-4.63z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M91.41 79.738h-2.045l6.546 31.404 2.454.151 6.137-.151h21.682l-8.591-32.48-13.091 1.076h-2.864l-3.682-1.076h-6.545z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M97.956 78.662h-6.545v1.076h-2.046l6.546 31.404 2.454.151 6.137-.151m-6.546-32.48 3.682 1.076h2.864l13.091-1.076 8.591 32.48h-21.682m-6.546-32.48c1.227 1.913 1.637 2.468 1.637 5.05s4.772 17.78 5.727 19.812m-.818 7.618s-2.537-7.08-2.864-9.949m13.091-19.812c1.364 6.398 5.727 23.894 5.727 26.327"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M8.364 77.108h9l.409-.389h4.5l.409-.388h8.182l2.454 1.165 2.046 31.078h-9.818l-1.228-1.554v1.554H11.636l1.228-4.273-3.682 5.05H1c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.819-7.77 1.228-9.712"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M30.455 108.574h4.909l-2.045-31.077-2.455-1.166h-1.227m.818 32.243h-4.91l-1.227-1.554v1.554H11.636l1.228-4.273-3.682 5.05H1c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.819-7.77 1.228-9.712h9l.409-.389h4.5l.409-.388h6.955m.818 32.243c-.682-5.698-1.964-18.491-1.637-24.085.328-5.594.682-7.77.819-8.158"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M17.364 114.013H2.636L1 109.351h8.182l3.682-5.05-1.228 4.273h12.682v-1.554l1.228 1.554h9.818l.41 4.662H23.09l-.818.388h-4.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M14.5 108.574h9.818v-1.554l1.228 1.554h9.818l.41 4.662H23.09l-.818.388h-4.5l-.41.389H2.637L1 109.351h5.727m7.773-.777h-2.863l1.227-4.273-3.682 5.05H6.727m7.773-.777c.955-4.662 3.11-15.073 4.091-19.423m-11.864 20.2 11.046-28.358V76.72"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M35.773 115.179v-6.215l31.092 1.942v4.273H47.228l-2.045.777z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M66.863 114.788v-6.216l29.864 2.331v4.662h-6.954l-10.228.777-3.273-.777zM96.729 115.643v-4.351h29.454v4.351h-17.35l-1.21 1.088z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M35.772 78.66h-2.045l2.045 30.301 2.046 2.719 6.136-.164 22.91-.613-6.955-32.243h-13.91l-3.681-1.165h-6.546z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M42.318 77.495h-6.546v1.165h-2.045l2.045 30.301 2.046 2.719 6.136-.164m-1.636-34.02 3.681 1.165h13.91l6.954 32.242-22.91.613m-1.635-34.02c1.227 2.07 3.681 6.914 3.681 9.71 0 2.798 1.91 7.9 2.864 10.101m-4.91 14.209c-1.09-7.973-3.354-24.698-3.68-27.805m15.545 0c1.363 6.93 4.09 21.45 4.09 24.085"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M61.956 77.108H59.91l6.955 31.466 2.045 2.719 6.137-.164h21.682l-8.591-35.187-13.091 1.166h-2.864l-3.682-1.166h-6.545z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M68.501 75.942h-6.545v1.166H59.91l6.955 31.466 2.045 2.719 6.137-.164M68.5 75.942l3.682 1.166h2.864l13.09-1.166 8.592 35.187H75.047M68.5 75.942c1.227 2.072 3.682 6.915 3.682 9.712s6.818 9.064 7.773 11.266m-4.91 14.209c-1.09-7.974-8.263-25.863-8.59-28.971m15.545 0c1.364 6.93 9 22.615 9 25.25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M198.594 79.738h-2.045l6.545 31.404 2.455.151 6.136-.151h21.682l-8.591-32.48-13.091 1.076h-2.863l-3.682-1.076h-6.546z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M205.14 78.662h-6.546v1.076h-2.045l6.545 31.404 2.455.151 6.136-.151m-6.545-32.48 3.682 1.076h2.863l13.091-1.076 8.591 32.48h-21.682m-6.545-32.48c1.227 1.913 1.636 2.468 1.636 5.05s4.773 17.78 5.728 19.812m-.819 7.618s-2.536-7.08-2.863-9.949m13.091-19.812c1.363 6.398 5.727 23.894 5.727 26.327"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M115.547 77.108h9l.409-.389h4.501l.409-.388h8.182l2.454 1.165 2.046 31.078h-9.819l-1.227-1.554v1.554H118.82l1.227-4.273-3.682 5.05h-8.181c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.818-7.77 1.227-9.712"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M137.638 108.574h4.91l-2.046-31.077-2.454-1.166h-1.228m.818 32.243h-4.909l-1.227-1.554v1.554H118.82l1.227-4.273-3.682 5.05h-8.181c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.818-7.77 1.227-9.712h9l.409-.389h4.501l.409-.388h6.954m.818 32.243c-.681-5.698-1.963-18.491-1.636-24.085s.682-7.77.818-8.158"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M124.547 114.013H109.82l-1.636-4.662h8.181l3.682-5.05-1.227 4.273h12.682v-1.554l1.227 1.554h9.819l.409 4.662h-12.682l-.818.388h-4.501z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M121.684 108.574h9.818v-1.554l1.227 1.554h9.819l.409 4.662h-12.682l-.818.388h-4.501l-.409.389H109.82l-1.636-4.662h5.727m7.773-.777h-2.864l1.227-4.273-3.682 5.05h-2.454m7.773-.777c.954-4.662 3.109-15.073 4.091-19.423m-11.864 20.2 11.045-28.358V76.72"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M142.957 115.179v-6.215l31.091 1.942v4.273h-19.636l-2.046.777z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M174.047 114.788v-6.216l29.864 2.331v4.662h-6.955l-10.227.777-3.273-.777zM203.912 115.643v-4.351h29.455v4.351h-17.35l-1.211 1.088z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M142.956 78.66h-2.046l2.046 30.301 2.045 2.719 6.137-.164 22.909-.613-6.955-32.243h-13.909l-3.682-1.165h-6.545z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M149.501 77.495h-6.545v1.165h-2.046l2.046 30.301 2.045 2.719 6.137-.164m-1.637-34.02 3.682 1.165h13.909l6.955 32.242-22.909.613m-1.637-34.02c1.227 2.07 3.682 6.914 3.682 9.71 0 2.798 1.909 7.9 2.864 10.101m-4.909 14.209c-1.091-7.973-3.355-24.698-3.682-27.805m15.545 0c1.364 6.93 4.091 21.45 4.091 24.085"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M169.139 77.108h-2.045l6.954 31.466 2.046 2.719 6.136-.164h21.682l-8.591-35.187-13.091 1.166h-2.863l-3.682-1.166h-6.546z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M175.685 75.942h-6.546v1.166h-2.045l6.954 31.466 2.046 2.719 6.136-.164m-6.545-35.187 3.682 1.166h2.863l13.091-1.166 8.591 35.187H182.23m-6.545-35.187c1.227 2.072 3.682 6.915 3.682 9.712s6.818 9.064 7.772 11.266m-4.909 14.209c-1.091-7.974-8.263-25.863-8.591-28.971m15.546 0c1.364 6.93 9 22.615 9 25.25"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M304.139 79.738h-2.045l6.545 31.404 2.455.151 6.136-.151h21.682l-8.591-32.48-13.091 1.076h-2.863l-3.682-1.076h-6.546z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M310.685 78.662h-6.546v1.076h-2.045l6.545 31.404 2.455.151 6.136-.151m-6.545-32.48 3.682 1.076h2.863l13.091-1.076 8.591 32.48H317.23m-6.545-32.48c1.227 1.913 1.636 2.468 1.636 5.05s4.773 17.78 5.727 19.812m-.818 7.618s-2.536-7.08-2.863-9.949m13.091-19.812c1.363 6.398 5.727 23.894 5.727 26.327"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M221.092 77.108h9l.409-.389h4.5l.41-.388h8.181l2.455 1.165 2.045 31.078h-9.818l-1.227-1.554v1.554h-12.682l1.227-4.273-3.682 5.05h-8.181c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.818-7.77 1.227-9.712"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M243.183 108.574h4.909l-2.045-31.077-2.455-1.166h-1.227m.818 32.243h-4.909l-1.227-1.554v1.554h-12.682l1.227-4.273-3.682 5.05h-8.181c2.045-6.216 6.136-19.424 6.136-22.531 0-3.108.818-7.77 1.227-9.712h9l.409-.389h4.5l.41-.388h6.954m.818 32.243c-.681-5.698-1.963-18.491-1.636-24.085s.682-7.77.818-8.158"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M230.092 114.013h-14.727l-1.636-4.662h8.181l3.682-5.05-1.227 4.273h12.682v-1.554l1.227 1.554h9.818l.41 4.662H235.82l-.819.388h-4.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M227.229 108.574h9.818v-1.554l1.227 1.554h9.818l.41 4.662H235.82l-.819.388h-4.5l-.409.389h-14.727l-1.636-4.662h5.727m7.773-.777h-2.864l1.227-4.273-3.682 5.05h-2.454m7.773-.777c.954-4.662 3.109-15.073 4.091-19.423m-11.864 20.2 11.045-28.358V76.72"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M248.502 115.179v-6.215l31.091 1.942v4.273h-19.636l-2.046.777zM279.594 114.788v-6.216l29.864 2.331v4.662h-6.955l-10.227.777-3.273-.777z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M309.457 115.643v-4.351h29.455v4.351h-17.35l-1.211 1.088z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M248.503 78.66h-2.046l2.046 30.301 2.045 2.719 6.136-.164 22.91-.613-6.955-32.243H258.73l-3.682-1.165h-6.545z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M255.048 77.495h-6.545v1.165h-2.046l2.046 30.301 2.045 2.719 6.136-.164m-1.636-34.02 3.682 1.165h13.909l6.955 32.242-22.91.613m-1.636-34.02c1.227 2.07 3.682 6.914 3.682 9.71 0 2.798 1.909 7.9 2.864 10.101m-4.91 14.209c-1.091-7.973-3.354-24.698-3.681-27.805m15.545 0c1.364 6.93 4.091 21.45 4.091 24.085"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M274.684 77.108h-2.045l6.954 31.466 2.046 2.719 6.136-.164h21.682l-8.591-35.187-13.091 1.166h-2.863l-3.682-1.166h-6.546z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M281.23 75.942h-6.546v1.166h-2.045l6.954 31.466 2.046 2.719 6.136-.164m-6.545-35.187 3.682 1.166h2.863l13.091-1.166 8.591 35.187h-21.682m-6.545-35.187c1.227 2.072 3.682 6.915 3.682 9.712s6.818 9.064 7.772 11.266m-4.909 14.209c-1.091-7.974-8.264-25.863-8.591-28.971m15.546 0c1.363 6.93 9 22.615 9 25.25"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M410.504 77.796h-2.045l6.545 31.404 2.455.151 6.136-.151h21.683l-8.591-32.48-13.092 1.076h-2.863l-3.682-1.076h-6.546z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M417.05 76.72h-6.546v1.076h-2.045l6.545 31.404 2.455.151 6.136-.151m-6.545-32.48 3.682 1.076h2.863l13.092-1.076 8.591 32.48h-21.683m-6.545-32.48c1.227 1.912 1.636 2.468 1.636 5.05s4.773 17.78 5.728 19.812m-.819 7.618s-2.536-7.08-2.863-9.95m13.091-19.811c1.364 6.397 5.727 23.894 5.727 26.326"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M327.457 75.166h9.001l.409-.389h4.5l.409-.388h8.182l2.454 1.165 2.046 31.078h-9.819l-1.227-1.554v1.554H330.73l1.227-4.274-3.681 5.05h-8.182c2.045-6.215 6.136-19.423 6.136-22.53s.818-7.77 1.227-9.712"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M349.549 106.632h4.909l-2.046-31.078-2.454-1.165h-1.228m.819 32.243h-4.91l-1.227-1.554v1.554H330.73l1.227-4.274-3.681 5.05h-8.182c2.045-6.215 6.136-19.423 6.136-22.53s.818-7.77 1.227-9.712h9.001l.409-.389h4.5l.409-.388h6.954m.819 32.243c-.682-5.698-1.964-18.492-1.637-24.086s.682-7.769.818-8.157"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M336.458 112.07H321.73l-1.636-4.661h8.182l3.681-5.05-1.227 4.273h12.682v-1.554l1.227 1.554h9.819l.409 4.661h-12.682l-.818.389h-4.5z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M333.594 106.632h9.818v-1.554l1.227 1.554h9.819l.409 4.661h-12.682l-.818.389h-4.5l-.409.388H321.73l-1.636-4.661h5.727m7.773-.777h-2.864l1.227-4.273-3.681 5.05h-2.455m7.773-.777c.954-4.662 3.109-15.073 4.091-19.424m-11.864 20.201 11.046-28.359v-4.273"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M354.867 113.237v-6.216l31.091 1.943v4.273h-19.636l-2.046.777z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M385.957 112.845v-6.215l29.864 2.331v4.661h-6.955l-10.227.777-3.273-.777zM415.822 113.7v-4.35h29.455v4.35h-17.35l-1.21 1.088z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M354.866 76.718h-2.046l2.046 30.301 2.045 2.719 6.137-.164 22.909-.613-6.955-32.243h-13.909l-3.682-1.165h-6.545z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M361.411 75.553h-6.545v1.165h-2.046l2.046 30.301 2.045 2.719 6.137-.164m-1.637-34.021 3.682 1.165h13.909l6.955 32.243-22.909.613m-1.637-34.021c1.228 2.072 3.682 6.915 3.682 9.711s1.909 7.9 2.864 10.1m-4.909 14.21c-1.091-7.974-3.355-24.698-3.682-27.806m15.545 0c1.364 6.93 4.091 21.45 4.091 24.085"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M381.049 75.165h-2.045l6.955 31.466 2.045 2.72 6.136-.165h21.682L407.231 74l-13.091 1.165h-2.863L387.595 74h-6.546z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M387.595 74h-6.546v1.165h-2.045l6.955 31.466 2.045 2.72 6.136-.165M387.595 74l3.682 1.165h2.863L407.231 74l8.591 35.186H394.14M387.595 74c1.227 2.072 3.682 6.915 3.682 9.712s6.818 9.064 7.773 11.265m-4.91 14.209c-1.091-7.973-8.263-25.863-8.591-28.97m15.546 0c1.364 6.93 9 22.615 9 25.25"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m375.619 92.18-11.344 4.39 11.344 5.124 10.246-5.123z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m381.84 175.657-6.221 3.659v-77.623l10.246-5.123z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m367.848 177.38 7.771 1.936v-77.623l-11.344-5.123z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "m399.129 112.636-23.399 18.389v9.02l33.546-27.409z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m340.989 110.998 24.923 19.677v8.141l-36-27.818z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#87662A",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m340.548 110.998 25.364 19.637v-2.709l-21.841-16.928z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m81.891 92.995-8.889 3.944 8.89 3.7 10.245-4.116z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m88.111 160.059-6.22 2.939v-62.36l10.246-4.116z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m74.12 161.444 7.771 1.555v-62.36l-8.889-3.7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "m58.274 114.271 15.136 14.728v9.818l-25.364-24.546z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#87662A",
    stroke: "#000",
    d: "m58.683 114.681 14.727 14.318v-3.273l-10.636-11.045z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M362.586 169.808c-9.181 1.101-15.629 3.694-15.629 6.717 0 4.022 11.417 7.283 25.5 7.283s25.5-3.261 25.5-7.283c0-2.696-5.128-5.05-12.75-6.309",
    opacity: 0.3
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M405 176.819c0-3.768-6.536-7.059-16.25-8.819m-16.25 19c-17.949 0-32.5-4.558-32.5-10.181",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316,
    cy: 89.5,
    fill: "#000",
    fillOpacity: 0.36,
    rx: 50,
    ry: 9.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bridge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CF8D47",
    d: "M364.069 49.554c12.581 42.35-14.115 39.993-46.157 39.993-36.451 0-54.513 1.947-52.801-24.874 2.109-33.046 24.077-45.903 38.272-50.395a47 47 0 0 1 5.826-1.066c-2.856-2.272-8.225-7.09-6.854-8.187 1.713-1.37 6.168 1.714 8.567 0s5.141-5.483 9.596-3.427 3.084 4.455 7.539 3.427c4.456-1.028 7.883-1.028 2.742 4.798-3.833 4.344-5.582 4.197-5.802 4.157 15.186 3.34 32.634 13.903 39.072 35.574"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M309.209 13.212a47 47 0 0 0-5.826 1.066c-14.195 4.492-36.163 17.349-38.272 50.395-1.712 26.82 16.35 24.874 52.801 24.874 32.042 0 58.738 2.356 46.157-39.993-6.442-21.682-23.905-32.245-39.096-35.579m-15.764-.763c-2.856-2.272-8.225-7.09-6.854-8.187 1.713-1.37 6.168 1.714 8.567 0s5.141-5.483 9.596-3.427 3.084 4.455 7.539 3.427c4.456-1.028 7.883-1.028 2.742 4.798-4.112 4.66-5.826 4.152-5.826 4.152m-15.764-.763a48 48 0 0 1 4.798-.325m10.966 1.088a47 47 0 0 0-4.53-.763m0 0 3.502-6.816m-3.502 6.816a48 48 0 0 0-6.436-.325m0 0c-1.029-1.25-3.085-4.024-3.085-5.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73F3F",
    stroke: "#000",
    d: "M312.978 9.479c-5.809.726-5.492 2.84-5.141 3.77 0 0 4.113-.343 8.911-.343 5.446 0 10.281 1.37 10.281 1.37.685-3.083-5.826-5.825-14.051-4.797Z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M23.211 149.594a6 6 0 0 1 4.94-2.594h215.436c1.798 0 2.967 1.892 2.163 3.5s.365 3.5 2.163 3.5h162.436c1.973 0 3.82.97 4.94 2.594l11.724 17c2.745 3.98-.104 9.406-4.939 9.406H208.776c-1.818 0-2.763-2.167-1.526-3.5s.292-3.5-1.526-3.5H16.426c-4.835 0-7.684-5.426-4.939-9.406z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bridge_svg__a",
    width: 103.248,
    height: 89.578,
    x: 264.5,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_10098"
  })))));
};
export default SvgBridge;